"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
const colors_1 = require("../colors");
const custom_1 = require("./custom");
exports.theme = custom_1.createThemeFromColor('#F8F9FA', 'light-blue', 'Xanh lam nhạt', {
    tintColor: '#1F3247',
    override: {
        primaryBackgroundColor: colors_1.getStaticColors({ isDark: false }).blue,
    },
});
//# sourceMappingURL=light-blue.js.map